export default __webpack_public_path__ + "static/media/Bo.6bdbd114.png";